import { TinySpinner } from 'components/shared/TinySpinner/TinySpinner';
import type { UseScreenshotOptions } from 'hooks/useScreenshot';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';
import styled from 'styled-components';

type LiferingModalWithScreenshotProps = {
  onClose: () => void;
  isOpened: boolean;
  defaultMessage?: string;
} & UseScreenshotOptions;
const StyledTinySpinner = styled(TinySpinner)`
  position: absolute;
  left: -10em;
  top: 0.9em;
`;

const LiferingModalWithScreenshotLazy = lazyWithRetry(() => import('./LiferingModalWithScreenshot'));

export function Fallback() {
  return <StyledTinySpinner size={1.5} className="text-secondary" />;
}
export function LiferingModalWithScreenshot({
  isOpened,
  onClose,
  defaultMessage,
  ...props
}: LiferingModalWithScreenshotProps) {
  return (
    <Suspense fallback={<Fallback />}>
      <LiferingModalWithScreenshotLazy
        {...props}
        isOpened={isOpened}
        onClose={onClose}
        defaultMessage={defaultMessage}
      />
    </Suspense>
  );
}
